import axios from 'axios'
import router from '../../router'

const state = {
  sysadminCompanyTypeMaps: []
}

const getters = {
  getSysadminCompanyTypeMaps (state) {
    return state.sysadminCompanyTypeMaps
  }
}

const mutations = {
  setSysadminCompanyTypeMaps (state, payload) {
    state.sysadminCompanyTypeMaps = payload
  }
}

const actions = {
  apiSysadminCompanyTypeMaps (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      if (payload.method === 'POST') {
        axios.post('/api/sysadmin/companyTypeMaps', payload)
          .then((response) => {
            console.log(response.data)
            alert('저장되었습니다.')
            context.dispatch('apiSysadminCompanyTypeMaps', {'method': 'GET'})
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      } else if (payload.method === 'PATCH') {
        axios.patch('/api/sysadmin/companyTypeMaps/' + payload.id, payload)
          .then((response) => {
            console.log(response.data)
            alert('저장되었습니다.')
            context.dispatch('apiSysadminCompanyTypeMaps', {'method': 'GET'})
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      } else { // GET method
        axios.get('/api/sysadmin/companyTypeMaps')
          .then((response) => {
            console.log(response.data)
            context.commit('setSysadminCompanyTypeMaps', response.data)
            context.dispatch('apiCommonsStatus')
            context.dispatch('apiSysadminGroupsCombo')
          })
          .catch((error) => {
            alert(error.response.data.message)
            if (error.response.status === 410) {
              sessionStorage.removeItem('token')
              router.push('/sessiontimeout')
            }
          })
      }
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/sessiontimeout')
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/admincompanyauth.js